import { render, staticRenderFns } from "./AcademyPage.vue?vue&type=template&id=52177c90&scoped=true"
import script from "./AcademyPage.vue?vue&type=script&lang=js"
export * from "./AcademyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52177c90",
  null
  
)

export default component.exports